module.exports = __webpack_public_path__ + "static/14-c412208169317dd4e9183fb4fb8e4456.png";